<section class="event-practical-info" [ngClass]="{ 'card p-md-4': !showOnlyImportantInfo() }">
  <h1 class="sr-only">Praktische informatie</h1>

  <div class="row gutter-y-4">
    @if (!showOnlyImportantInfo()) {
      @if (event().locations?.length || event().departments?.length) {
        <div class="col-sm-12 col-md-8">
          <h2 class="h5">{{ 'agenda-detail-info-waar' | fromDictionary }}</h2>

          <ul>
            @for (location of event().locations; track location.id) {
              <li>
                {{ location.name }}
              </li>
            }
            @if (!event().locations?.length) {
              @for (location of event().departments; track location.id) {
                <li>
                  <a class="link-reset hover--underline" [routerLink]="['/agenda']" [queryParams]="{ departments: location.id }">
                    {{ location.name }}
                  </a>
                </li>
              }
            }
          </ul>
        </div>
      }

      <div class="col-sm-12 col-md-8">
        <h2 class="h5">{{ 'agenda-detail-info-wanneer' | fromDictionary }}</h2>
        <ul class="d-flex flex-column gap-2">
          <li class="d-flex align-items-center gap-2">
            <fstr-icon class="chip chip--secondary-subtle chip--xxs" anchor="line-icon-calendar"></fstr-icon>

            <span>{{ event().startDate | eventDate: event().endDate }}</span>
          </li>

          <!--@if (hasRecurrencePattern()) {
            <li class="d-flex align-items-center gap-2">
              <fstr-icon class="chip chip--secondary-subtle chip--xxs" anchor="line-icon-repeat"></fstr-icon>
              <span>{{ 'event-label-geweest-is-herhalend' | fromDictionary }}</span>
            </li>
          }-->

          @if (event().displayEventStartTime || event().displayEventEndTime) {
            <li class="d-flex align-items-center gap-2">
              <fstr-icon class="chip chip--secondary-subtle chip--xxs" anchor="line-icon-clock"></fstr-icon>

              <span>
                {{ event() | eventDateTime }}
              </span>
            </li>
          }
        </ul>
      </div>
    }

    @if (event().alert?.text || event().alert?.title) {
      <div class="col-sm-24 col-md-8 ms-auto">
        <!-- TODO repeating events exeption also (second) alert -->
        <app-alert [title]="event().alert?.title" [message]="event().alert?.text" [status]="'secondary'"></app-alert>
      </div>
    }
  </div>
</section>
